import { SavePartyMutation37kzgcr2r74ko as SavePartyMutation } from './schema/SavePartyMutation.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instance2n0ntuorxhisv as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance3qkyg4jh5rqfu as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_instance237ciysby2nz0 as Companion_instance_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PairingRule.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from './schema/type/SavePartyInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  yield* this.b6u(new (SavePartyMutation())(savePartyInput(command.q2k_1)), $completion);
  return Accepted_instance;
}
var SdkSavePartyCommandDispatcherClass;
function SdkSavePartyCommandDispatcher() {
  if (SdkSavePartyCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePartyCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePartyCommandDispatcherClass = $;
  }
  return SdkSavePartyCommandDispatcherClass;
}
function savePartyInput(_this__u8e3s4) {
  return new (SavePartyInput())(_this__u8e3s4.p2c_1, Companion_instance.f47(_this__u8e3s4.v2c_1), Companion_instance.f47(_this__u8e3s4.u2c_1), Companion_instance.f47(Companion_instance_0.o2c(_this__u8e3s4.q2c_1)), Companion_instance.f47(_this__u8e3s4.r2c_1), Companion_instance.f47(_this__u8e3s4.s2c_1), Companion_instance.f47(_this__u8e3s4.t2c_1), Companion_instance.f47(_this__u8e3s4.w2c_1), Companion_instance.f47(_this__u8e3s4.x2c_1), Companion_instance.f47(_this__u8e3s4.y2c_1));
}
//region block: exports
export {
  SdkSavePartyCommandDispatcher as SdkSavePartyCommandDispatcher1x5cidvmu3vb0,
  perform as perform14gugfzohs1yo,
};
//endregion

//# sourceMappingURL=SdkSavePartyCommandDispatcher.mjs.map
